export default {
  notification:{
    type:'success',
    content:null,
    callback:null
  },
  navigation:[],
  drawer:false,
  drawer_hidden:true,
  response:null,
  location:null,
  version:'1.0.0',
  config:{
    jwt:'jwtauth',
    rota:''
  }
}



// WEBPACK FOOTER //
// ./src/store/common/state.js